import React from "react";

const EmployeeUpdateDate = ({ row }) => {
  return (
    <div>
      {row?.roles?.map((role, index) => (
        <div style={{ marginBottom: "15px" }} key={index}>
          {role?.updateDate}
        </div>
      ))}
    </div>
  );
};

export default EmployeeUpdateDate;
